function timerFlash(obj, intDiff) {
    let day = 0,
        hour = 0,
        minute = 0,
        second = 0;
    intDiff = intDiff - 0;
    if (intDiff > 0) {
        hour = Math.floor(intDiff / 1000 / 60 / 60);
        minute = Math.floor((intDiff / 1000 / 60) % 60);
        second = Math.floor((intDiff / 1000) % 60);
    }
    const padZero = (value) => (value < 10 ? "0" + value : value);
    $(obj).find(".flash-deals_valH").text(padZero(hour));
    $(obj).find(".flash-deals_valD").text(padZero(minute));
    $(obj).find(".flash-deals_valS").text(padZero(second));
}

document.addEventListener('DOMContentLoaded', function () {
    const newdate = new Date();
    const s_year = newdate.getFullYear();
    const s_month = newdate.getMonth() + 1;
    const s_day = newdate.getDate();
    const s_time = newdate.toLocaleTimeString();
    console.log(s_time);
    const brandDay_start_time = s_year + "/" + s_month + "/" + s_day + " " + s_time;
    const brandDay_end_time = s_year + "/" + s_month + "/" + s_day + " " + "23:59:59";
    const startTime = new Date(brandDay_start_time);
    const endTime = new Date(brandDay_end_time);
    let endAllTime = endTime.getTime() - newdate;
    let limistTime = setInterval(function () {
        if (endAllTime > 0) {
            endAllTime = endAllTime - 1000;
            timerFlash(".flash-deals_box", endAllTime);
        }
    }, 1000);
});

function displayCurrentDates() {
        var currentDate = new Date();
        var options = { month: 'long', day: 'numeric' };
        var formattedDate = currentDate.toLocaleDateString('fr-FR', options);
        formattedDate = formattedDate.replace(/\b\w/g, function(char) {
            return char.toUpperCase();
        });
        var dateElements = document.querySelectorAll('.currentDate');
        dateElements.forEach(function(element) {
            element.textContent = formattedDate;
        });
}
displayCurrentDates();
setTimeout(function() {
  displayCurrentDates();
}, 3000);

//按钮抖动事件
function jsmobileshake(button) {
    // 监听动画结束事件，自动移除类名
  const removeShake = () => {
    button.classList.remove("shake");
    button.removeEventListener('animationend', removeShake);
  };

    button.addEventListener('animationend', removeShake);
    button.classList.add("shake");
}

  // 使用递归的 setTimeout 实现每3秒对所有按钮抖动
  (function repeatShake() {
  const buttons = document.querySelectorAll(".jsmobileshake");
  buttons.forEach(button => jsmobileshake(button));
  setTimeout(repeatShake, 3000);
})();
